import script from "./GlobalAssistantLauncher.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAssistantLauncher.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAssistantLauncher.vue?vue&type=style&index=0&id=66d10f80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d10f80"]])

export default __exports__